export default function () {
  const route = useRoute()
  let slug
  if (Array.isArray(route.params.slug)) {
    slug = slug.join('-')
  } else {
    slug = route.params.slug
  }
  return {
    slug,
  }
}
